class PromoCountdownBar extends HTMLElement {
  connectedCallback() {
    this.endTime = Date.parse(this.dataset.end || '');
    this.timerRoot = this.querySelector('[data-countdown-timer]');
    if (!this.endTime || !this.timerRoot) return;

    this.update();
    this.interval = window.setInterval(() => this.update(), 1000);
  }

  disconnectedCallback() {
    if (this.interval) window.clearInterval(this.interval);
  }

  update() {
    const remaining = this.endTime - Date.now();

    if (remaining <= 0) {
      this.classList.add('promo-countdown-bar--expired');
      this.timerRoot.innerHTML = '';
      if (this.interval) window.clearInterval(this.interval);
      return;
    }

    const totalSeconds = Math.floor(remaining / 1000);
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    this.timerRoot.innerHTML = `
      <div class="promo-countdown-bar__unit"><span class="promo-countdown-bar__value">${this.pad(days)}</span><span class="promo-countdown-bar__label">Day</span></div>
      <div class="promo-countdown-bar__unit"><span class="promo-countdown-bar__value">${this.pad(hours)}</span><span class="promo-countdown-bar__label">Hr</span></div>
      <div class="promo-countdown-bar__unit"><span class="promo-countdown-bar__value">${this.pad(minutes)}</span><span class="promo-countdown-bar__label">Min</span></div>
      <div class="promo-countdown-bar__unit"><span class="promo-countdown-bar__value">${this.pad(seconds)}</span><span class="promo-countdown-bar__label">Sec</span></div>
    `;
  }

  pad(value) {
    return String(value).padStart(2, '0');
  }
}

customElements.define('promo-countdown-bar', PromoCountdownBar);
